import Vue from 'vue';
import Component from 'vue-class-component';
import { Store } from '@/core/store/core.store';
import { Prop } from 'vue-property-decorator';
import EdHeaderInSession from '../ed-header-in-session/ed-header-in-session.vue';
import EdHeaderOutSession from '../ed-header-out-session/ed-header-out-session.vue';

@Component({
  name: 'ed-header',
  components: {
    EdHeaderInSession,
    EdHeaderOutSession
  }
})
class EdHeader extends Vue {

  get sidebarMenu(): boolean {
    return this.$store.state.AppStore.hasSidebarButton;
  }

  get header(): string {
    if(Store.state.AuthStore.user.id) {
      return 'ed-header-in-session';
    } else {
      return 'ed-header-out-session';
    }
  }

}

export default Vue.component('ed-header', EdHeader);

